import { create } from 'zustand';
import type { Feeling } from '@breath-lab/types';
import { getServices } from '@breath-lab/services';

interface FeelingsState {
  feelings: Feeling[];
  isLoaded: boolean;
  load: () => Promise<void>;
}

export const useFeelings = create<FeelingsState>((set, get) => ({
  feelings: [],
  isLoaded: false,

  load: async () => {
    if (get().isLoaded) return;
    try {
      const feelings = await getServices().data.fetchFeelings();
      set({ feelings, isLoaded: true });
    } catch {
      // non-blocking — UI degrades gracefully with empty chips
    }
  },
}));
